/**
 * Product card variant swatches: hovering/focusing a swatch that has its own
 * variant image swaps the card's main image; leaving the swatch row restores it.
 * Clicking a swatch is a plain link to the product with that variant selected.
 */
if (!customElements.get('ws-product-card')) {
  class WsProductCard extends HTMLElement {
    #abort = null;
    #original = null;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      const image = this.querySelector('.ws-product-card__media img');
      if (!image) return;

      for (const swatch of this.querySelectorAll('[data-swatch][data-variant-image]')) {
        swatch.addEventListener('pointerenter', () => this.#preview(image, swatch), { signal });
        swatch.addEventListener('focus', () => this.#preview(image, swatch), { signal });
        swatch.addEventListener('blur', () => this.#restore(image), { signal });
      }

      this.querySelector('.ws-product-card__swatches')?.addEventListener(
        'pointerleave',
        () => this.#restore(image),
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    #preview(image, swatch) {
      this.#original ??= { src: image.src, srcset: image.srcset, sizes: image.sizes };
      image.srcset = '';
      image.sizes = '';
      image.src = swatch.dataset.variantImage;
    }

    #restore(image) {
      if (!this.#original) return;
      image.src = this.#original.src;
      image.srcset = this.#original.srcset;
      image.sizes = this.#original.sizes;
      this.#original = null;
    }
  }

  customElements.define('ws-product-card', WsProductCard);
}
